import { TableCell } from "@mui/material";

export default function TableColumn(props: any) {
  const cellStyle = { padding: "8px 16px", fontSize: "14px",borderLeft:"2px solid #e7e7e7ff",borderRight:"2px solid #e7e7e7ff" };
  return <TableCell sx={cellStyle} key={props.key}>
    {props.label}
    </TableCell>;
}
